import { USE_GPS } from "../../../config/gpsConfig.js";

export async function loadMapData() {
  try {
    const dataJson = await import("../../../json/campus_data.json");

    const mapJson = await Promise.all(
      dataJson.default.campusList.map(async (campus) => {
        try {
          const data = await import(`../../../json/map_${campus.code}.json`);
          return data.default;
        } catch {
          return [];
        }
      })
    );

    const mapIconJson = await Promise.all(
      dataJson.default.campusList.map(async (campus) => {
        try {
          const data = await import(
            `../../../json/map_${campus.code}_icon.json`
          );
          return data.default;
        } catch {
          return [];
        }
      })
    );

    const mapModelJson = await Promise.all(
      dataJson.default.campusList.map(async (campus) => {
        if (!USE_GPS) return null;
        try {
          const data = await import(
            `../../../json/map_${campus.code}_model.json`
          );
          return data.default || data;
        } catch {
          return null;
        }
      })
    );

    const mapSvg = dataJson.default.campusList.map((campus) => {
      return `${process.env.PUBLIC_URL}/svg/map_${campus.code}.svg`;
    });

    return { mapJson, mapIconJson, mapModelJson, mapSvg };
  } catch (error) {
    console.error("Error loading map data:", error);
    throw error;
  }
}
